import { useParams } from "react-router-dom";
import UsersPage from "./UsersPage";
import UserDetailPage from "./UserDetailPage";

// Whitelist of segments that should be treated as a tab on the UsersPage.
// Anything else is interpreted as a user id (numeric) or slug (e.lafage…).
const USER_TABS = new Set(["all", "followed"]);

/**
 * Dispatch component for /users/:segment? :
 *   - missing or in USER_TABS  → list view (UsersPage)
 *   - otherwise                → detail view (UserDetailPage with id=segment)
 *
 * Lets us use clean path-based URLs (/users/followed, /users/e.lafage)
 * without ambiguity at the router level.
 */
export default function UsersRouter() {
  const { segment } = useParams();
  if (!segment || USER_TABS.has(segment)) {
    return <UsersPage />;
  }
  // The route param is named :segment, so pass it explicitly — UserDetailPage
  // must not read useParams().id (which would be undefined here, leaving the
  // page stuck on its loading skeleton with no request fired).
  return <UserDetailPage id={segment} />;
}
